module.exports = __webpack_public_path__ + "img/2-1.a3a4c538.png";